import * as React from 'react';

import {ErrorMessage} from '../form/error-message';
import {StackLegacy} from '../layout/stack/stack-legacy';
import {SelectPickerGeneric} from '../select-picker-generic/select-picker-generic';
import {TextField} from '../textfield/textfield';

import styles from './select-picker-inline-text.module.css';

export type SelectOption = {
    label: string;
    value: string;
};

type Props = {
    selectOptions: SelectOption[];
    selectedOption: SelectOption | null | undefined;
    inlineText: string;
    onSelectChange: (option: SelectOption) => void;
    onInlineTextChange: (value: string) => void;
    onSubmit: () => void;
    placeholder?: string;
    selectDisabled?: boolean;
    errorMessage?: string | null | undefined;
    focusOnMount?: boolean;
};

export function SelectPickerInlineText(props: Props) {
    return (
        <StackLegacy isFullWidth={true} justifyContent='center' spacing={8}>
            <div className={styles.grid}>
                <div className={styles.container}>
                    <SelectPickerGeneric
                        labelKey='label'
                        valueKey='value'
                        options={props.selectOptions}
                        onChange={props.onSelectChange}
                        value={props.selectedOption}
                        isClearable={false}
                        isSearchable={false}
                        noBorder={true}
                        minHeight={34}
                        isDisabled={props.selectDisabled}
                    />
                    <div className={styles.textfield}>
                        <TextField
                            placeholder={props.placeholder}
                            value={props.inlineText}
                            onChange={props.onInlineTextChange}
                            noBorder={true}
                            onEnter={props.onSubmit}
                            focusOnMount={props.focusOnMount}
                        />
                    </div>
                </div>
            </div>
            {props.errorMessage && <ErrorMessage>{props.errorMessage}</ErrorMessage>}
        </StackLegacy>
    );
}
